import { Paper, PaperProps, styled } from '@mui/material';

export const PaperStyled = styled(Paper)<PaperProps>(({ theme }) => ({
  '&.MuiPaper-root .MuiAutocomplete-noOptions': {
    color: `${theme.palette.text.primary}`,
  },
  '& .MuiAutocomplete-loading': {
    color: theme.palette.text.primary,
  },
}));
